import Nav from "./Sections-Home/nav";

export default function Contact() {

    return (
        <Nav />
    );
}